module.exports = __webpack_public_path__ + "img/colivia_vit.b864931d.svg";